import { create } from "zustand";
import { initialState, TCategoryStore } from "./category.state";
import { createCategoryActions } from "./category.actions";

/**
 * State management store of the V3 search - Categories metadata
 * @example
 * ```
 * const categories = useCategoryStore((state) => state.categories)
 * const dispatch = useCategoryStore((state) => state.dispatch)
 * const filtered = getCategoriesByProperty({ disclosureId: 2 })
 * dispatch({ type: SearchActions.SET_CATEGORY_ITEM, payload: categoryItem })
 * ```
 */
export const useCategoryStore = create<TCategoryStore>((set, get) => ({
    ...initialState,
    ...createCategoryActions(set, get),
}));
